import { EventEmitter } from '@apia/util';
import { useEffect, useState } from 'react';

export enum SessionStatus {
  Alive,
  Dead,
}

class Session extends EventEmitter<{
  change: SessionStatus;
}> {
  #isAlive = true;

  get isAlive() {
    return this.#isAlive;
  }

  invalidate() {
    this.#isAlive = false;
    this.emit('change', SessionStatus.Dead);
  }
}

const session = new Session();

export function useSessionState() {
  const [state, setState] = useState(SessionStatus.Alive);

  useEffect(() => {
    return session.on('change', setState);
  }, []);

  return state;
}

export { session };
